import api from '../../boot/openapi';
import ApiError from './error';

const InvoiceService = {
  async get(id) {
    const client = await api.getClient();
    try {
      return await client.getInvoice(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default InvoiceService;
